<template>
  <NoteList
          :delete-permission="'delete_auction'"
          :change-permission="'change_auction'"
          :object-uuid="reservation.uuid"
          plural-object-name="inventories/reservations" object-name="reservation" :is-loading-text="false"/>
</template>

<script>
  import NoteList from "./../../../notes/NotesList";
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('reservations');

  export default {
    name: "Notes",
    components: {NoteList},
    computed: {
      ...mapState({
        reservation: state => state.view.currentReservation,
      }),
    },
  }
</script>

<style scoped>

</style>
